// When surfaces rise out of the background (Tailwind's animate-rise).
//
// The app's first appearance is staged: the loading screen's logo sinks,
// the panel rises partway through, then its cards and the nav follow. After
// that, panels stay put and only cards rise, all at once, whenever they first
// appear.

const ENTRANCE_PANEL_DELAY_MS = 240;
const ENTRANCE_CARD_DELAY_MS = 420;
const ENTRANCE_NAV_DELAY_MS = 420;
/** How long after the entrance starts that something mounting is part of it. */
const ENTRANCE_WINDOW_MS = 1200;

let entranceStartedAt: number | null = null;

/** Called as the loading screen starts to leave. */
export function startAppEntrance(): void {
  entranceStartedAt = performance.now();
}

/** Time left until `delayMs` into the entrance, or null outside it. */
function entranceDelay(delayMs: number): number | null {
  if (entranceStartedAt === null) return null;
  const elapsed = performance.now() - entranceStartedAt;
  if (elapsed > ENTRANCE_WINDOW_MS) return null;
  return Math.max(0, delayMs - elapsed);
}

/** A panel's rise delay, or null when it should simply appear. */
export function panelRiseDelay(): number | null {
  return entranceDelay(ENTRANCE_PANEL_DELAY_MS);
}

/**
 * When the main nav fades in, all of it at once, with the selected item's tab
 * rising as it does; or null outside the entrance.
 */
export function navRiseDelay(): number | null {
  return entranceDelay(ENTRANCE_NAV_DELAY_MS);
}

/** A card's rise delay: after the panel during the entrance, else none. */
export function cardRiseDelay(): number {
  return entranceDelay(ENTRANCE_CARD_DELAY_MS) ?? 0;
}
